'use client'

import { useRouter } from 'next/navigation'

import { Button, Text } from '@/shared/ui'

import cl from './personal-account-banner.module.scss'

const PERSONAL_ORDERS_PATH = '/personal/orders/'

type PersonalAccountBannerProps = {
	onNavigate?: () => void
}

export const PersonalAccountBanner = ({ onNavigate }: PersonalAccountBannerProps) => {
	const router = useRouter()

	const handleClick = () => {
		onNavigate?.()
		router.push(PERSONAL_ORDERS_PATH)
	}

	return (
		<div className={cl.operator}>
			<div className={cl.operator__textBlock}>
				<Text weight="semibold">Информация о заказах</Text>
				<Text size="1">доступна в личном кабинете</Text>
			</div>

			<Button className={cl.operator__button} onClick={handleClick}>
				Перейти&nbsp;&nbsp;→
			</Button>
		</div>
	)
}
